// extracted by mini-css-extract-plugin
module.exports = {"floatingButton":"DevToolsFloatingButton_floatingButton__3I_Rs","icon":"DevToolsFloatingButton_icon__2U-_I","label":"DevToolsFloatingButton_label__3bwMj"};